import { Route, Routes } from "react-router-dom";
import Dashboard from "../../Pages/Dashboard";
import Site from "../../Pages/Site";
import Settings from "../../Pages/Settings";
import Messages from "../../Pages/Messages";
import Folders from "../../Pages/Folders";
import ToolSettings from "../../Pages/ToolSettings";
import Stores from "../../Pages/Stores";
import Sensor from "../../Pages/Sensor";
import Reports from "../../Pages/Reports";
import Help from "../../Pages/Help";
import Account from "../../Pages/Account";
import Users from "../../Pages/Users";
import Subscription from "../../Pages/Subscription";
import Preferences from "../../Pages/Preferences";
import Insight from "../../Pages/Insight";
function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Dashboard />}></Route>
      <Route path="/stores/*" element={<Stores />}></Route>
      <Route path="/sensor/*" element={<Sensor />}></Route>
      <Route path="/reports/*" element={<Reports />}></Route>
      <Route path="/help/*" element={<Help />}></Route>
      <Route path="/site/*" element={<Site />}></Route>
      <Route path="/settings/*" element={<Settings />}></Route>
      <Route path="/messages/*" element={<Messages />}></Route>
      <Route path="/folders/*" element={<Folders />}></Route>
      <Route path="/toolSettings/*" element={<ToolSettings />}></Route>
      <Route path="/account/*" element={<Account />}></Route>
      <Route path="/users/*" element={<Users />}></Route>
      <Route path="/subscription/*" element={<Subscription />}></Route>
      <Route path="/preferences/*" element={<Preferences />}></Route>
      <Route path="/insight/*" element={<Insight />}></Route>
    </Routes>
  );
}
export default AppRoutes;
